const errorMessages = {
    auth_failed: 'These credentials do not match our records.',
    user_locked:
        "Your account has been locked for security reasons. To unlock it, please contact customer support at 920028928 or email us at support{'@'}foodics.com.",
    too_many_attempts: 'Too many attempts. Please try again later.',
    too_many_login_attempts:
        'Your account has been temporarily locked due to multiple failed login attempts. Please try again later.',
    unauthorized: 'Unauthorized.',
    unauthorized_operation:
        'Unauthorized Operation. OTP is invalid or expired. Please request a new one.',
    missing_authorization_header: 'Missing Authorization header.',
    incorrect_otp:
        'Incorrect code. Please try again. ({attempts} attempts remaining.)',
    otp_attempts_exceeded:
        'You have exceeded the maximum number of attempts. Please try again later.',
    verification_attempts_exceeded:
        'Your account has been locked due to too many failed attempts. Please contact support.',
    verify_phone_resend_not_ready:
        'You can request a verification code resend in {seconds} second(s).',
    phone_update_not_ready:
        'You can request a phone update link in {seconds} second(s).',
    password_reset_failed: "We can't find a user with that email address.",
    reset_token_invalid: 'This password reset token is invalid.',
    reset_email_not_found: "We can't find a user with that email address.",
    cannot_update_own_role: 'You can not update your own role.',
    invitation_already_accepted: 'This invitation has been accepted already.',
    invitation_expired: 'This invitation has expired.',
    user_not_invited: 'User is not in invited status.',
    invitation_not_found: 'Invitation not found.',
    operation_not_permitted: 'This operation is not permitted on this user.',
    transfer_not_scheduled: 'Failed to send this payment',
    transfer_receipt_failed:
        'Could not generate receipt at this time. Please try again later.',
    transfer_cancel_not_allowed: 'Failed to cancel this payment',
    only_scheduled_transfers_can_be_updated: 'Failed to edit this payment',
    transfer_status_not_retriable: 'Failed to retry this payment.',
    ongoing_or_successful_retry: 'Failed to retry this payment.',
    transfer_retry_not_ready:
        'You can request a retry again in {seconds} second(s).',
    approval_denied: 'Another approval at the same level has rejected it',
    approval_sibling_decided:
        'Another approval at the same level has already been decided.',
    poll_not_found: 'Poll not found.',
    role_name_exists: 'A role with this name already exists.',
    iban_invalid: 'This IBAN is invalid.',
    phone_update_invalid_signature: 'The update link is invalid or expired.',
    beneficiary_has_ongoing_transfers:
        "Can't delete this beneficiary because it has ongoing payments",
} as const;
export default errorMessages;
export type ErrorCode = keyof typeof errorMessages;
